import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { useHubStore } from '@/lib/store/hubStore';
import { isSuccess } from '@/lib/utils/response';
import { UserHub } from '@addmile/backend-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UserData {
  user: UserHub;
}

export const useUpdateUserEmail = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, email }: { userId: string; email: string }) => {
      const token = await getAuthToken();
      const response = await hubApi.updateUserEmailHub(userId, { email }, withAuthHeader(token));
      if (!isSuccess(response.status)) {
        throw new Error(response.statusText || 'Failed to update email');
      }
      return email;
    },

    onSuccess: (newEmail, { userId }) => {
      const hubStore = useHubStore.getState();
      if (hubStore.searchUserData?.id === userId) {
        useHubStore.setState({
          searchUserData: {
            ...hubStore.searchUserData,
            email: newEmail,
          },
        });
      }

      queryClient
        .getQueryCache()
        .findAll()
        .forEach((query) => {
          if (Array.isArray(query.queryKey) && query.queryKey[0] === 'users') {
            const data = queryClient.getQueryData(query.queryKey) as UserData;

            if (data?.user?.id === userId) {
              queryClient.setQueryData(query.queryKey, {
                ...data,
                user: { ...data.user, email: newEmail },
              });
            }
          }
        });
    },
  });
};
